export const CUSTOM_ROUTE_PLACEHOLDERS = {
  postSlug: '**postSlug**',
  postId: '**postId**',
};
